export default __webpack_public_path__ + "static/media/screen4.e2f5511f.png";